import React from 'react';
import PropTypes from 'prop-types';
import { Map, Marker, APILoader } from '@uiw/react-baidu-map';

export default function BaiduMap({ mapHeight, mapWidth, latitude, longitude }) {
  if (!latitude || !longitude) {
    return <div>Invalid coordinates</div>;
  }

  return (
    <div
      style={{
        width: mapWidth,
        height: mapHeight,
      }}
    >
      <APILoader akay="Hdi0MSFtCOQm7GDi3fdvrL1r44XKrEYL">
        <Map
          zoom={12}
          center={{
            lng: longitude,
            lat: latitude,
          }}
        >
          <Marker
            position={{
              lng: longitude,
              lat: latitude,
            }}
          />
        </Map>
      </APILoader>
    </div>
  );
}

BaiduMap.propTypes = {
  mapHeight: PropTypes.string,
  mapWidth: PropTypes.string,
  latitude: PropTypes.number,
  longitude: PropTypes.number,
};

BaiduMap.defaultProps = {
  mapHeight: '400px',
  mapWidth: '100%',
  latitude: 22.5726,
  longitude: 88.3639,
};
